import _get from 'lodash/get';

import { Base } from '@/models';
import { toCamelCase } from '@/utilities';

/**
 * Interface defines the syntax properties which the Address class must follow
 */
interface AddressInterface {
  line1: string;
  line2?: string;
  town: string;
  county?: string;
  postcode: string;
  country?: string;
  phone?: string;
	mobile?: string;
  email?: string;
}

/**
 * Address Class implements AddressInterface - therefore must follow the structure provided by the interface.
 */
export class Address extends Base implements AddressInterface {
  /**
   * A string defining the first line of an address
   */
  public line1: string;

  /**
   * A string defining the second line of an address
   */
  public line2: string;

  /**
   * A string defining the town
   */
  public town: string;

  /**
   * A string defining the county
   */
  public county: string;

  /**
   * A string defining the postcode
   */
  public postcode: string;

  /**
   * A string defining the country
   */
  public country: string;

  public phone: string;
	public mobile: string;
  public email: string;

  /**
   * Constructor initialises the variables from the class Address
   * @param data - the data to construct a type with all properties of <Address>
   */
  public constructor(data?: Partial<Address>) {
    super(data);
    data = toCamelCase(data);

    this.line1 = _get(data, 'line1', '');
    this.line2 = _get(data, 'line2', '');
    this.town = _get(data, 'town', '');
    this.county = _get(data, 'county', '');
    this.postcode = _get(data, 'postcode', '');
    this.country = _get(data, 'country', '');
    this.phone = _get(data, 'phone', '');
		this.mobile = _get(data, 'mobile', '');
    this.email = _get(data, 'email', '');
  }

  public compare(address: Address): boolean {
    if (this.line1.toLocaleLowerCase() != address.line1.toLocaleLowerCase()) return false;
    if (this.line2.toLocaleLowerCase() != address.line2.toLocaleLowerCase()) return false;
    if (this.town.toLocaleLowerCase() != address.town.toLocaleLowerCase()) return false;
    if (this.county.toLocaleLowerCase() != address.county.toLocaleLowerCase()) return false;
    if (this.postcode.toLocaleLowerCase() != address.postcode.toLocaleLowerCase()) return false;
    return true;
  }

}
